module.exports = __webpack_public_path__ + "img/Frame 1143one2.75b1f007.png";